import styled, { keyframes } from "styled-components";
// Animation for fade-in (chỉ khai báo 1 lần duy nhất, đặt ngay sau import)
export const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
`;

// Section Contact
export const ContactSection = styled.section`
  width: 100vw;
  background: #e3f0ff;
  padding: 56px 0 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: ${fadeIn} 1.1s ease; 
`;

export const ContactTitle = styled.h2`
  font-size: 2rem;
  font-weight: 800;
  color: #007bff;
  margin-bottom: 32px;
`;

export const ContactInfo = styled.div`
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(0,123,255,0.08);
  padding: 32px 40px 28px 40px;
  max-width: 420px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
  font-size: 1.1rem;
`;

export const ContactRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: #007bff;
  font-weight: 600;
`;

export const ContactText = styled.span`
  color: #333;
  font-weight: 400;
`;


// Section FAQ
export const FAQSection = styled.section`
  width: 100vw;
  background: #fff;
  padding: 56px 0 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: ${fadeIn} 1.1s ease; 
`;

export const FAQTitle = styled.h2`
  font-size: 2rem;
  font-weight: 800;
  color: #007bff;
  margin-bottom: 32px;
`;

export const FAQList = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FAQItem = styled.div`
  background: #f7fafc;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0,123,255,0.06);
  padding: 22px 28px 18px 28px;
  display: flex;
  flex-direction: column;
`;

export const FAQQuestion = styled.div`
  font-weight: 700;
  color: #007bff;
  font-size: 1.1rem;
  margin-bottom: 8px;
`;

export const FAQAnswer = styled.div`
  color: #444;
  font-size: 1rem;
`;



// Section feedback/học viên tiêu biểu
export const FeedbackSection = styled.section`
  width: 100vw;
  background: #f7fafc;
  padding: 56px 0 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: ${fadeIn} 1.1s ease; 
`;

export const FeedbackTitle = styled.h2`
  font-size: 2rem;
  font-weight: 800;
  color: #007bff;
  margin-bottom: 32px;
`;

export const FeedbackList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  justify-content: center;
`;

export const FeedbackItem = styled.div`
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(0,123,255,0.08);
  padding: 28px 24px 20px 24px;
  max-width: 320px;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const FeedbackAvatar = styled.img`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 14px;
  border: 3px solid #e3f0ff;
`;

export const FeedbackName = styled.div`
  font-weight: 700;
  color: #007bff;
  margin-bottom: 6px;
`;

export const FeedbackText = styled.p`
  color: #444;
  font-size: 1rem;
  margin-bottom: 0;
`;



// Section block hình ảnh/giới thiệu
export const IntroSection = styled.section`
  width: 100vw;
  background: #fff;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 48px 0 32px 0;
  gap: 32px;
  animation: ${fadeIn} 1.1s ease; 
`;

export const IntroImage = styled.img`
  width: 380px;
  max-width: 90vw;
  border-radius: 18px;
  box-shadow: 0 4px 32px rgba(0,123,255,0.10);
  object-fit: cover;
`;

export const IntroContent = styled.div`
  max-width: 480px;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const IntroTitle = styled.h2`
  font-size: 2rem;
  font-weight: 800;
  color: #007bff;
  margin-bottom: 16px;
`;

export const IntroText = styled.p`
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 12px;
`;


// Form đăng ký nổi bật dưới Hero
export const RegisterFormWrapper = styled.div`
  width: 100vw;
  display: flex;
  justify-content: center;
  margin-top: -24px;
  margin-bottom: 32px;
  position: relative;
  z-index: 2;
`;

export const RegisterForm = styled.form`
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 8px 32px rgba(0,123,255,0.10);
  padding: 32px 32px 24px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 340px;
  max-width: 420px;
  width: 100%;
  animation: ${fadeIn} 1.1s ease;
`;

export const RegisterTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 10px;
  color: #007bff;
`;

export const RegisterDesc = styled.p`
  color: #444;
  font-size: 1rem;
  margin-bottom: 18px;
`;

export const RegisterInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 16px;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
  transition: border 0.2s;
  &:focus {
    border: 1.5px solid #007bff;
  }
`;

export const RegisterButton = styled.button`
  width: 100%;
  background: linear-gradient(90deg, #ffb300 0%, #ff6f00 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 0;
  font-size: 1.1rem;
  font-weight: 700;
  margin-top: 8px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(255,183,77,0.10);
  transition: background 0.2s;
  &:hover {
    background: linear-gradient(90deg, #ff6f00 0%, #ffb300 100%);
  }
`;


export const Wrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f7fafc 0%, #e3f0ff 100%);
  font-family: 'Inter', Arial, sans-serif;
`;

export const Hero = styled.section`
  width: 100vw;
  min-height: 650px;
  background: url('https://static.ladipage.net/5b7b7b6b7b7b7b0001b7b7b7/hero-bg-betia-20230822034913.jpg') center/cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 48px;
  padding-bottom: 0;
  position: relative;
  text-align: center;
  animation: ${fadeIn} 0.8s ease;
`;

export const HeroTitle = styled.h1`
  font-size: 3.2rem;
  font-weight: 900;
  margin-bottom: 18px;
  color: #fff;
  text-shadow: 0 4px 24px rgba(0,0,0,0.18);
  letter-spacing: 1px;
`;

export const HeroDesc = styled.p`
  font-size: 1.35rem;
  margin-bottom: 16px;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0,0,0,0.12);
`;

export const CTAButton = styled.button`
  background: linear-gradient(90deg, #00bfff 0%, #007bff 100%);
  color: #fff;
  border: none;
  border-radius: 32px;
  padding: 0.9rem 2.2rem;
  font-size: 1.2rem;
  font-weight: 700;
  box-shadow: 0 4px 24px rgba(0,123,255,0.18);
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4,0,0.2,1);
  margin-bottom: 18px;
  &:hover {
    background: linear-gradient(90deg, #007bff 0%, #0056b3 100%);
    transform: translateY(-2px) scale(1.04);
    box-shadow: 0 8px 32px rgba(0,123,255,0.28);
  }
`;

export const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 48px 16px 32px 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  justify-content: center;
  animation: ${fadeIn} 1.2s ease; 
`;

export const Feature = styled.div`
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(0, 123, 255, 0.08);
  padding: 32px 28px 28px 28px;
  flex: 1 1 320px;
  min-width: 300px;
  max-width: 370px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0 8px 32px rgba(0, 123, 255, 0.18);
    transform: translateY(-4px) scale(1.03);
  }
`;

export const FeatureIcon = styled.div`
  font-size: 2.8rem;
  margin-bottom: 18px;
  color: #007bff;
`;

export const FeatureTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 10px;
`;

export const FeatureDesc = styled.p`
  color: #444;
  font-size: 1rem;
`;

export const Footer = styled.footer`
  background: #f7fafc;
  color: #888;
  text-align: center;
  padding: 28px 0 12px 0;
  font-size: 1rem;
  border-top: 1px solid #e3e3e3;
`;